<template>
    <textarea name="comment" :style="styles" cols="40" :rows="rowsValue"
      v-model="innerValue">
    </textarea>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class InputTextarea extends Vue {
  @Prop({ required: true }) value!: string

  @Prop() rows!: number

  @Prop() styles: any

  private rowsValue: number = 3

  private created() {
    if (this.rows) {
      this.rowsValue = this.rows
    }
  }

  private get innerValue(): string {
    return this.value
  }

  private set innerValue(text: string) {
    this.$emit('input', text)
  }
}
</script>

<style scoped>
textarea {
  border-radius: 5px;
  width: 100%;
  border-style: none;
}
</style>
